import { takeLatest, call, put, all } from 'redux-saga/effects';
import Tracking from '~/config/tracking';
import * as api from '~/services/api';
import { transFormErrorResponse } from '../utils';
import * as actions from './actions';
import { orderGameweeks } from './utils';

export function* getClubsFilters({ payload: { query = '' } }) {
  try {
    const { data } = yield call(api.getClubs, query);
    yield put(actions.getClubFiltersSuccess(data));
  } catch (err) {
    yield put(actions.getClubFiltersFailure());
    Tracking.trackApiError(transFormErrorResponse(err), { showAs: 'toast' });
  }
}

export function* getCompetitionFilters({ payload: { query = '' } }) {
  try {
    const { data } = yield call(api.getCompetitions, query);
    yield put(actions.getCompetitionFiltersSuccess(data));
  } catch (err) {
    yield put(actions.getCompetitionFiltersFailure());
    Tracking.trackApiError(transFormErrorResponse(err), { showAs: 'toast' });
  }
}

export function* getSeasonFilters({ payload: { query = '' } }) {
  try {
    const { data } = yield call(api.getSeasons, query);
    yield put(actions.getSeasonFiltersSuccess(data));
  } catch (err) {
    yield put(actions.getSeasonFiltersFailure());
    Tracking.trackApiError(transFormErrorResponse(err), { showAs: 'toast' });
  }
}

export function* getDateFilters({ payload: { query = '' } }) {
  try {
    const { data } = yield call(api.getClubs, query);
    yield put(actions.getDateFiltersSuccess(data));
  } catch (err) {
    yield put(actions.getDateFiltersFailure());
    Tracking.trackApiError(transFormErrorResponse(err), { showAs: 'toast' });
  }
}

export function* getStadiumFilters({ payload: { query = '' } }) {
  try {
    const { data } = yield call(api.getStadiums, query);
    yield put(actions.getStadiumFiltersSuccess(data));
  } catch (err) {
    yield put(actions.getStadiumFiltersFailure());
    Tracking.trackApiError(transFormErrorResponse(err), { showAs: 'toast' });
  }
}

export function* getCarouselDatesFilters({ payload: { query = '' } }) {
  try {
    const { data } = yield call(api.getCarouselDates, query);
    data.gameweeks = orderGameweeks(data.gameweeks);
    yield put(actions.getCarouselDatesFiltersSuccess(data));
  } catch (err) {
    yield put(actions.getCarouselDatesFiltersFailure());
    Tracking.trackApiError(transFormErrorResponse(err), { showAs: 'toast' });
  }
}

export default all([
  takeLatest(actions.Types.GET_CLUBS_REQUEST, getClubsFilters),
  takeLatest(actions.Types.GET_COMPETITIONS_REQUEST, getCompetitionFilters),
  takeLatest(actions.Types.GET_SEASONS_REQUEST, getSeasonFilters),
  takeLatest(actions.Types.GET_DATES_REQUEST, getDateFilters),
  takeLatest(actions.Types.GET_STADIUMS_REQUEST, getStadiumFilters),
  takeLatest(actions.Types.GET_CAROUSEL_DATES_REQUEST, getCarouselDatesFilters),
]);
